import { render, staticRenderFns } from "./tier.vue?vue&type=template&id=4543fd34&scoped=true&"
import script from "./tier.vue?vue&type=script&lang=js&"
export * from "./tier.vue?vue&type=script&lang=js&"
import style0 from "./tier.vue?vue&type=style&index=0&id=4543fd34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543fd34",
  null
  
)

export default component.exports